import { useState, useEffect } from 'react';

interface PreloadImagesProps {
  imageUrls: string[];
  usePreload: boolean;
}

export const usePreloadImages = ({ imageUrls, usePreload }: PreloadImagesProps): boolean => {
  const [imagesLoaded, setImagesLoaded] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true; // 用于检测组件是否已经被卸载
    let loadedCount = 0; // 用于跟踪已加载的图片数量
    let errorCount = 0;

    const loadImage = (url: string): Promise<void> =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          // eslint-disable-next-line no-plusplus
          loadedCount++;
          if (loadedCount + errorCount === imageUrls.length && isMounted) {
            setImagesLoaded(true); // 所有图片加载完成后，设置 imagesLoaded 为 true
          }
          resolve();
        };
        img.onerror = () => {
          // eslint-disable-next-line no-plusplus
          errorCount++;
          if (loadedCount + errorCount === imageUrls.length && isMounted) {
            setImagesLoaded(true); // 所有图片加载完成后，如果有图片加载失败，则将 imagesLoaded 设置为 true
          }
          reject(new Error(`Failed to load image: ${url}`));
        };
        img.src = url;
      });

    if (usePreload) {
      imageUrls.forEach((url) => {
        loadImage(url).catch((error) => {
          // 这里可以处理加载失败的逻辑，例如显示一个错误消息或者重新尝试加载
          // eslint-disable-next-line no-console
          console.error(error);
        });
      });
    } else {
      setImagesLoaded(true);
    }

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [imageUrls, usePreload]);

  return imagesLoaded;
};
